import { Component, Inject, OnInit, OnDestroy } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Subscription } from "rxjs";
import { BuisnessPromotion, ServiceList } from "src/app/models/common";
import { ApiService } from "src/app/providers/api.service";
import { SM_CONSTANTS } from "../../constants/sm-constants";
import { FormControl } from "@angular/forms";
import { THIS_EXPR } from "@angular/compiler/src/output/output_ast";
import { ActivatedRoute } from "@angular/router";
import { SharedService } from "../../../providers/shared.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { AuthService } from "src/app/providers/auth.service";

@Component({
  selector: "sm-inventory-items-for-purchase",
  templateUrl: "./inventory-items-for-purchase.component.html",
  styleUrls: ["./inventory-items-for-purchase.component.scss"],
})
export class InventoryItemsForPurchaseComponent implements OnInit, OnDestroy {
  public purchaseListData: any = {
    payment_amount: 0,
  };
  public newInventoryData: any = {};
  isDiscount!: boolean;
  isShop: boolean = false;
  isHome: boolean = false;
  isPercent!: boolean;
  isAmount!: boolean;
  isHomeSpecific: Boolean = false;
  isShopSpecific: Boolean = false;
  entityHash: string = "";
  operation_type: any;
  hideRequiredControl = new FormControl(false);
  public fileName: string = "";
  private _apiSubscription: Subscription = new Subscription();
  public editMode: boolean = false;
  public loader: boolean = false;
  public removable: boolean = true;
  public assetList: any[] = [];
  public page: number = 1;
  inventoryItems: any[] = [];
  inventoryTemplateData: any[] = [];
  selectedInventoryData: any[] = [];
  selectedInventoryTemplateData: any[] = [];
  datalength!: number;
  toShowInventoryItems: boolean = false;
  toShowInventoryTemplate: boolean = true;
  showInventoryAdd: boolean = false;
  searchString: FormControl = new FormControl("");
  selectedPurchaseType: number = 2;
  pageTitle: string = "";
  toshowdate: boolean = false;
  maxDate: Date = new Date();
  constructor(
    @Inject(MAT_DIALOG_DATA) public parentData: any,
    private _apiService: ApiService,
    private _snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private sharedService: SharedService,
    private loaderservice: LoaderServiceService,
    private authService: AuthService,
    public dialog: MatDialogRef<InventoryItemsForPurchaseComponent>
  ) {}
  removeAsset() {
    this.purchaseListData.imgUrl = "";
    this.assetList = [];
  }
  changeChip(value: number) {
    this.selectedPurchaseType = value;
    // this.loader = true
    // this._apiService.getEntitySlotsInfo(this.entityHashId, this.bookingType, this.selectedValue)
  }
  isOwner: boolean = false;
  ngOnInit(): void {
    this.isOwner = this.authService.isOwner();

    console.log(this.parentData);
    this.operation_type = this.parentData.operation_type;
    this.pageTitle = this.parentData.title;
    if (this.parentData.operation_type == 1) {
      this.toShowInventoryItems = true;
    } else if (this.parentData.operation_type == 3) {
      this.selectedPurchaseType = 1;
    }

    // else if(this.parentData.operation_type == 2){
    //   this.toShowInventoryItems = false
    // }
    this.route.queryParams.subscribe((data) => {
      console.log(data.entityHash);
      this.entityHash = data.entityHash;
      if (this.toShowInventoryItems) {
        this.loader = true;
        this._apiService.getInventoryItems(
          this.entityHash,
          this.page,
          this.searchString.value ?? ""
        );
      }
      // if(this.toShowInventoryTemplate){
      //   this._apiService.getInventoryTemplateDataByKeyword(this.page,this.searchString.value ?? '')
      // }
    });
    let data: any;
    if (this.parentData.purchaseData) {
      // console.log(this.parentData.purchaseData);
      console.log(this.selectedPurchaseType);

      data = this.parentData.purchaseData;
      if (data.purchase_hash_id) {
        this.selectedInventoryData = [];
        this.selectedInventoryData.push(data);
        (this.purchaseListData.hash_id = data.purchase_hash_id),
          (this.purchaseListData.item_name = data.item_name),
          (this.purchaseListData.item_desc = data.item_desc),
          (this.purchaseListData.purchase_qty = data.purchase_quantity),
          (this.purchaseListData.purchase_unit = data.purchase_unit),
          (this.purchaseListData.purchase_price = data.purchase_price),
          (this.purchaseListData.current_stock = data.current_stock),
          (this.purchaseListData.notes = data.notes),
          (this.purchaseListData.min_stock = data.min_stock),
          (this.purchaseListData.selling_qty = data.selling_quantity),
          (this.purchaseListData.selling_unit = data.selling_unit),
          (this.purchaseListData.selling_purchase_multiplier =
            data.selling_purchase_multiplier),
          (this.selectedPurchaseType =
            this.parentData.operation_type == 3
              ? this.selectedPurchaseType
              : data.purchase_status);
        this.editMode = true;
        this.toShowInventoryItems = false;
      }
    }

    this._apiSubscription = this._apiService.apiResult.subscribe((res) => {
      console.log("Response", res);
      if (res.responseType === SM_CONSTANTS.UPLOAD_RESULT) {
        console.log(res.result);
        this.assetList = [];
        this.assetList = [
          {
            assetName: this.fileName,
            url: res.result?.url,
            thumbnail: res.result?.thumbnail,
          },
        ];
        this.purchaseListData.imgUrl = res.result?.url;
        this.loader = false;
      }

      if (res.responseType === SM_CONSTANTS.RESULT_API_GET_INVENTORY_ITEMS) {
        // this.inventoryItems = [];
        console.log(res);
        if (res.result) {
          this.datalength = res.result[0].totalCount;
          // this.datalength = 0;
          res.result.forEach((element: any) => {
            element.selected = false;
            this.inventoryItems.push(element);
          });
        } else {
          this.datalength = 0;
        }
        this.loaderservice.showLoader = false;
        this.loader = false;
      } else if (
        res.responseType === SM_CONSTANTS.RESULT_API_ADD_EDIT_PURCHASE_ITEM
      ) {
        if (res.result && res.result != null) {
          this.parentData.ref.closeAll();
        }
      }
    });
  }
  change(event: any) {
    console.log(event);
    if (event.checked == true && event.source.value == "home") {
      this.isHomeSpecific = true;
      this.purchaseListData.homeStatus = 1;
    }
    if (event.checked == true && event.source.value == "shop") {
      this.isShopSpecific = true;
      this.purchaseListData.shopStatus = 1;
    }
    if (event.checked == false && event.source.value == "home") {
      this.isHomeSpecific = false;
      this.purchaseListData.homeStatus = 0;
      this.purchaseListData.home_rate = null;
      this.purchaseListData.homeDiscountedPrice = null;
    }
    if (event.checked == false && event.source.value == "shop") {
      this.isShopSpecific = false;
      this.purchaseListData.shopStatus = 0;
      this.purchaseListData.shop_rate = null;
      this.purchaseListData.shopDiscountedPrice = null;
    }
  }

  onApp(event: any) {
    if (event.target.value == "applicable") {
      this.purchaseListData.discountStatus = 1;
    }
    if (event.target.value == "not-applicable") {
      this.purchaseListData.discountStatus = 0;
      this.purchaseListData.discountAmount = null;
      this.purchaseListData.discountType = null;
      this.isPercent = false;
      this.isAmount = false;
      this.purchaseListData.homeDiscountedPrice = null;
      this.purchaseListData.shopDiscountedPrice = null;
    }
  }

  discType(event: any) {
    if (event.target.value == "percent") {
      this.purchaseListData.discountType = 1;
    }
    if (event.target.value == "amount") {
      this.purchaseListData.discountType = 2;
    }
  }

  ngOnDestroy() {
    this._apiSubscription.unsubscribe();
    this.inventoryItems = [];
    this.page = 1;
  }

  checkDateFilled() {
    if (this.selectedPurchaseType == 1) {
      if (this.purchaseListData.purchase_date) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }
  checkPurchasePriceFilled() {
    if (this.selectedPurchaseType == 1) {
      if (
        this.purchaseListData.purchase_price &&
        this.purchaseListData.purchase_price != 0
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  formatDate1(dateStr: Date) {
    let curdate = new Date(dateStr)
      .toLocaleString("en-CA", {
        timeZone: "Asia/Kolkata",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .slice(0, 10);
    console.log(curdate);

    return curdate;
  }

  formatDateString(datestr: Date): string {
    const datePart = new Date(datestr); // Date provided
    const timePart = new Date(); // Current time

    const year = datePart.getFullYear();
    const month = String(datePart.getMonth() + 1).padStart(2, "0");
    const day = String(datePart.getDate()).padStart(2, "0");

    const hours = String(timePart.getHours()).padStart(2, "0");
    const minutes = String(timePart.getMinutes()).padStart(2, "0");
    const seconds = String(timePart.getSeconds()).padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  onPost() {
    if (this.editMode) {
      // if(this.operation_type == 2){
      if (this.selectedPurchaseType == 1) {
        //purchase

        let bodydata = {
          hash_id: this.purchaseListData.hash_id,
          entity_hash_id: this.entityHash,
          inv_item_hash: this.selectedInventoryData[0].inventory_item_hash_id,
          purchase_qty: +this.purchaseListData.purchase_qty,
          purchase_unit: this.selectedInventoryData[0].purchase_unit,
          purchase_status: this.selectedPurchaseType, //1 = purchase, 2=reminder,3 = cancelled,0=delete
          purchase_price: this.purchaseListData.purchase_price ?? 0,
          payment_amount: this.purchaseListData.payment_amount ?? 0,
          notes: this.purchaseListData.notes ?? "",
          status: 1,
          purchase_date: this.formatDateString(
            this.purchaseListData.purchase_date
          ),
          barcode: this.purchaseListData.barcode ?? "",
          createdByHash: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
          createdByemployeeHash: localStorage.getItem(
            SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
          ),
          selling_qty:
            Math.round(
              +this.purchaseListData.purchase_qty *
                this.purchaseListData.selling_purchase_multiplier *
                100
            ) / 100,
          selling_unit: this.purchaseListData.selling_unit,
          selling_purchase_multiplier:
            this.purchaseListData.selling_purchase_multiplier,
          creatorByType: this.isOwner ? 1 : 2, //1 = entity, 2 = employee
        };
        console.log(bodydata);
        this.loaderservice.showLoader = true;
        this._apiService.addEditPurchaseItem(bodydata);
      } else if (this.selectedPurchaseType == 2) {
        //reminder
        let bodydata = {
          hash_id: this.purchaseListData.hash_id,
          entity_hash_id: this.entityHash,
          inv_item_hash: this.selectedInventoryData[0].inventory_item_hash_id,
          purchase_qty: +this.purchaseListData.purchase_qty,
          purchase_unit: this.selectedInventoryData[0].purchase_unit,
          purchase_status: this.selectedPurchaseType, //1 = purchase, 2=reminder,3 = cancelled,0=delete
          purchase_price: 0,
          payment_amount: 0,
          notes: this.purchaseListData.notes ?? "",
          status: 1,
          barcode: this.purchaseListData.barcode ?? "",
          createdByHash: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
          createdByemployeeHash: localStorage.getItem(
            SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
          ),
          creatorByType: this.isOwner ? 1 : 2,
          selling_qty:
            Math.round(
              +this.purchaseListData.purchase_qty *
                this.purchaseListData.selling_purchase_multiplier *
                100
            ) / 100,
          selling_unit: this.purchaseListData.selling_unit,
          selling_purchase_multiplier:
            this.purchaseListData.selling_purchase_multiplier,
        };
        console.log(bodydata);
        this.loaderservice.showLoader = true;
        this._apiService.addEditPurchaseItem(bodydata);
      }
    } else {
      if (this.selectedPurchaseType == 1) {
        //purchase
        const date = new Date();
        const currentDate = this.formatDate(date.toLocaleDateString());
        let bodydata = {
          // "hash_id": "46d08f125e86d31a8d4efd4b7b82a592c1ff94ef",
          entity_hash_id: this.entityHash,
          inv_item_hash: this.selectedInventoryData[0].hash_id,
          purchase_qty: +this.purchaseListData.purchase_qty,
          purchase_unit: this.selectedInventoryData[0].purchase_unit,
          purchase_status: this.selectedPurchaseType, //1 = purchase, 2=reminder,3 = cancelled,0=delete
          purchase_price: this.purchaseListData.purchase_price ?? 0,
          payment_amount: this.purchaseListData.payment_amount ?? 0,
          notes: this.purchaseListData.notes ?? "",
          status: 1,
          purchase_date: this.formatDateString(
            this.purchaseListData.purchase_date
          ),
          barcode: this.purchaseListData.barcode ?? "",
          createdByHash: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
          createdByemployeeHash: localStorage.getItem(
            SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
          ),
          creatorByType: this.isOwner ? 1 : 2,
          selling_qty:
            Math.round(
              +this.purchaseListData.purchase_qty *
                +this.selectedInventoryData[0].selling_purchase_multiplier *
                100
            ) / 100,
          selling_unit: this.selectedInventoryData[0].selling_unit,
          selling_purchase_multiplier:
            this.selectedInventoryData[0].selling_purchase_multiplier,
        };
        console.log(bodydata);
        this.loaderservice.showLoader = true;
        this._apiService.addEditPurchaseItem(bodydata);
      } else if (this.selectedPurchaseType == 2) {
        let bodydata = {
          // "hash_id": "46d08f125e86d31a8d4efd4b7b82a592c1ff94ef",
          entity_hash_id: this.entityHash,
          inv_item_hash: this.selectedInventoryData[0].hash_id,
          purchase_qty: +this.purchaseListData.purchase_qty,
          purchase_unit: this.selectedInventoryData[0].purchase_unit,
          purchase_status: this.selectedPurchaseType, //1 = purchase, 2=reminder,3 = cancelled,0=delete
          purchase_price: 0,
          payment_amount: 0,
          notes: this.purchaseListData.notes ?? "",
          status: 1,
          barcode: this.purchaseListData.barcode ?? "",
          createdByHash: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
          createdByemployeeHash: localStorage.getItem(
            SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
          ),
          creatorByType: this.isOwner ? 1 : 2,
          selling_qty:
            Math.round(
              +this.purchaseListData.purchase_qty *
                +this.selectedInventoryData[0].selling_purchase_multiplier *
                100
            ) / 100,
          selling_unit: this.selectedInventoryData[0].selling_unit,
          selling_purchase_multiplier:
            this.selectedInventoryData[0].selling_purchase_multiplier,
        };
        console.log(bodydata);
        this.loaderservice.showLoader = true;
        this._apiService.addEditPurchaseItem(bodydata);
      }
    }
  }

  onUploadImage(event: any) {
    this.loader = true;
    console.log(event.target.files);
    if (event.target.value === "") {
      this.loader = false;
      return;
    }
    this.fileName = event.target.files[0].name;
    let sizeinKb = +event.target.files[0].size / 1000;
    if (sizeinKb > 1021) {
      this._snackBar.open("Image size should not exceed more then 1 mb", "Ok");
      return;
    }
    let formData: FormData = new FormData();
    formData.append("recfile", event.target.files[0]);
    this._apiService.uploadAssets(formData, 1);
  }

  selectInventoryTemplate(item: any) {
    this.selectedInventoryData = [];
    this.inventoryItems.forEach((element: any) => {
      element.selected = false;
    });
    item.selected = true;

    this.selectedInventoryData.push(item);
  }
  selectInventoryTemplateDataByKeyword(item: any) {
    this.selectedInventoryTemplateData = [];
    this.inventoryTemplateData.forEach((element: any) => {
      element.selected = false;
    });
    item.selected = true;

    this.selectedInventoryTemplateData.push(item);
  }

  onSelectNext() {
    this.toShowInventoryItems = false;
    this.pageTitle = "Purchase item";
  }
  onSelectNextOnTemplateData() {
    //map for edit

    this.newInventoryData.item_name =
      this.selectedInventoryTemplateData[0].item_name;
    this.newInventoryData.item_desc =
      this.selectedInventoryTemplateData[0].item_desc;
    this.newInventoryData.qty_info =
      this.selectedInventoryTemplateData[0].quantity_info;

    this.assetList = [];
    if (
      this.selectedInventoryTemplateData[0].image_url &&
      this.selectedInventoryTemplateData[0].image_thumb_url != "null"
    ) {
      this.assetList.push({
        assetName: this.selectedInventoryTemplateData[0]?.image_url
          .split("/")
          .pop()
          .substring(
            this.selectedInventoryTemplateData[0].image_url
              .split("/")
              .pop()
              .lastIndexOf("_") + 1
          ),
        url: this.selectedInventoryTemplateData[0]?.image_url,
        thumbnail: this.selectedInventoryTemplateData[0]?.image_thumb_url,
      });
    }

    this.toShowInventoryTemplate = false;
    this.showInventoryAdd = true;
  }

  back() {
    this.toShowInventoryItems = true;
    this.pageTitle = this.parentData.title;
  }
  backFromInventoryTemplate() {
    this.showInventoryAdd = false;
    this.toShowInventoryTemplate = true;
  }

  seeMore() {
    this.loaderservice.showLoader = true
    this.page += 1;
    this._apiService.getInventoryItems(
            this.entityHash,
            this.page,
            this.searchString.value ?? ""
          );
    // this._apiService.getServiceTemplates(this.page);
  }

  onPageChange(ev: any) {
    console.log(ev?.pageIndex + 1);
    this.page = ev?.pageIndex + 1;
    this._apiService.getServiceTemplates(this.page);
  }

  reset() {
    this.loader = true
    this.inventoryItems = []
    this.searchString.reset();
    this.page = 1;
    if (this.parentData.operation_type == 4) {
      this._apiService.getInventoryTemplateDataByKeyword(
        this.page,
        this.searchString.value ?? ""
      );
    } else {
      this._apiService.getInventoryItems(
        this.entityHash,
        this.page,
        this.searchString.value ?? ""
      );
    }
  }
  firstTimeBelow3: boolean = false;
  debounceTimer: any; // Declare this at the class level
  searchServiceData() {
    clearTimeout(this.debounceTimer); // Clear previous timer

    this.debounceTimer = setTimeout(() => {
      if (this.searchString.value.length >= 3) {
        this.loader = true
        this.inventoryTemplateData = [];
        this.inventoryItems = [];
        this.firstTimeBelow3 = true;
        this.page = 1;
        if (this.parentData.operation_type == 4) {
          this._apiService.getInventoryTemplateDataByKeyword(
            this.page,
            this.searchString.value ?? ""
          );
        } else {
          this._apiService.getInventoryItems(
            this.entityHash,
            this.page,
            this.searchString.value ?? ""
          );
        }
      } else {
        if (this.firstTimeBelow3) {
          this.loader = true
          this.inventoryTemplateData = [];
          this.inventoryItems = [];
          this.firstTimeBelow3 = false;
          this.page = 1;
          if (this.parentData.operation_type == 4) {
            this._apiService.getInventoryTemplateDataByKeyword(this.page, "");
          } else {
            this._apiService.getInventoryItems(this.entityHash, this.page, "");
          }
        }
      }
    }, 300); // Delay in ms
  }

  formatDate(dateStr: string) {
    // Split the date string by `/`
    const parts = dateStr.split("/");

    // Reverse the order of the parts and join them with `-`
    const newDateStr = parts.reverse().join("-");

    // Return the formatted date string
    return newDateStr;
  }
}
